import { SubHeader } from "src/components";

import { useState } from "react";
import CompanyMasterComponent from "./company-master.component";
import ClusterMasterComponent from "../cluster-master/cluster-master.component";

const CompanyClusterLayoutComponent = () => {
  const [activeTab, setActiveTab] = useState("company");


  return (
    <div className="w-full">
      <SubHeader />
      <header className="flex flex-col px-[3.75rem] py-5 border-b-[1px] border-b-[#E9E9E9]">
        <div className="flex gap-6 mb-4">
          <button
            className={`pb-2 border-b-2 hover:text-purple-400 cursor-pointer ${activeTab === "company" ? "border-[#7F56D9] text-[#7F56D9]" : "border-transparent text-gray-600"}`}
            onClick={() => setActiveTab("company")}
          >
            Company
          </button>
          <button
            className={`pb-2 border-b-2 hover:text-purple-400 cursor-pointer ${activeTab === "cluster" ? "border-[#7F56D9] text-[#7F56D9]" : "border-transparent text-gray-600"}`}
            onClick={() => setActiveTab("cluster")}
          >
            Cluster
          </button>
        </div>
      {activeTab=="cluster" &&<ClusterMasterComponent></ClusterMasterComponent>}
      {activeTab=="company" &&<CompanyMasterComponent></CompanyMasterComponent>}
      </header>
    </div>
  );
};

export default CompanyClusterLayoutComponent;
